import {
  Component, Input, Output, OnChanges, OnInit, ViewEncapsulation, EventEmitter,
  SimpleChanges
} from '@angular/core'
import { FormGroup } from '@angular/forms'

import { DISPLAY_TYPE_ID_MAP, Question, QUESTION_TYPES_ID_MAPPING, UserAnswer } from '../../../data/models'
import { QuestionViewFormMapper, PromptControlService } from '../../../forms/services'
import { Form } from '../../../forms/models'
import { QuestionViewService, IQuestionAnswer } from './'
import { ModelFactory } from '../../../data/factories/index'
import { ExamState } from '../../../core/services'

@Component({
  selector: 'mp-question-view',
  templateUrl: './question-view.html',
  styleUrls: ['./question-view.scss'],
  encapsulation: ViewEncapsulation.None
})
export class QuestionViewComponent implements OnChanges, OnInit {
  @Input() public question: Question
  @Input() public reviewMode: boolean = false
  @Input() public disabled: boolean = false
  @Input() public hideAnswers: boolean = false
  @Input() public userAnswers: UserAnswer[] = []
  @Input() public extraText = {
    header: '',
    footer: ''
  }
  @Input() public stateMetadata = {}

  @Output() public questionAnswerChanged: EventEmitter<UserAnswer[]> = new EventEmitter()

  public form: Form<Question>
  public formGroup: FormGroup
  public QUESTION_TYPES = QUESTION_TYPES_ID_MAPPING
  public DisplayTypes = DISPLAY_TYPE_ID_MAP
  public showAnswer = true

  private _config: {}

  public get config() {
    const layoutConfig = this.stateMetadata['customLayout'] || {}
    const modifiedConfig = Object.assign({}, this._config, layoutConfig)
    return this._isContextLeft() ? Object.assign({}, modifiedConfig, { layout: 'vertical' }) : modifiedConfig
  }

  public get layoutClass(): string {
    return this._isContextLeft() ? 'col-xs-12 col-sm-6 horizontal' : 'col-xs-12'
  }

  public constructor(
    private _questionViewFormMapper: QuestionViewFormMapper,
    private _promptService: PromptControlService,
    private _questionViewService: QuestionViewService,
    private _modelFactory: ModelFactory,
    private _examState: ExamState
  ) { }

  public ngOnInit() {
    this._questionViewService.questionAnswered.subscribe((questionAnswers: IQuestionAnswer[]) => {
      const userAnswers = this._createUserAnwer(questionAnswers)
      this.questionAnswerChanged.emit(userAnswers)
    })
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.question) {
      this.showAnswer = !this.hideAnswers
      this._questionViewService.question = this.question
      this.form = this._questionViewFormMapper.toForm(this.question, this.userAnswers)
      this.formGroup = this._promptService.toFormGroup(this.form.prompts)
    }
    this._questionViewService.reviewMode = this.reviewMode
    if (this.reviewMode || this.disabled) {
      this.formGroup.disable()
    } else {
      setTimeout(() => this.formGroup.enable(), 0)
    }
    this._config = this._examState.testExecution ? this._examState.testExecution.test.config : {}
  }

  public toggleShowAnswer() {
    this.showAnswer = !this.showAnswer
  }

  public getQuestionContextText(questionContext: {}, section: {}): String {
    const sectionTopicText = {
      'verbal': 'this passage',
      'math': 'the following data'
    }
    return (questionContext['begin_index'] === questionContext['last_index']) ?
      `Question ${questionContext['last_index']} is based on ${sectionTopicText[section['topic']]}` :
      `Questions ${questionContext['begin_index']} to ${questionContext['last_index']} are based on ${sectionTopicText[section['topic']]}`
  }

  private _createUserAnwer(questionAnswers: IQuestionAnswer[]): UserAnswer[] {
    return questionAnswers.map((questionAnswer) => {
      const answerChoice = this.question.answerChoices.find((_answerChoice) => _answerChoice.id === questionAnswer.choiceId)
      const userAnswerData = {
        answerChoice: answerChoice,
        value: questionAnswer.value
      }
      return this._modelFactory.createAndInitialize<UserAnswer>(UserAnswer.name, userAnswerData)
    })
  }

  private _isContextLeft(): boolean {
    return this.question.questionContext && this.question.questionContext.position === 'left'
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/question-view/question-view.component.ts